
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css" integrity="sha512-Kc323vGBEqzTmouAECnVceyQqyqdsSiqLQISBL29aUW4U/M7pSPA/gEUZQqv1cwx4OnYxTxve5UMg5GT6L4JJg==" crossorigin="anonymous" referrerpolicy="no-referrer" />
  <section class="page-header position-relative overflow-hidden ptb-120 bg-dark" style="background: url('../../../../assets/images/land/page-header-bg\ \(1\).svg')no-repeat bottom left">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <h1 class="display-5 fw-bold">Contact Us</h1>
                <p class="lead">Seamlessly actualize client-based users after out-of-the-box value data through
                    frictionless expertise.</p>
            </div>
        </div>
        <div class="bg-circle rounded-circle circle-shape-3 position-absolute bg-dark-light right-5"></div>
    </div>
</section>
<div class="container p-4" *ngIf="loading">
  <app-header-spinner>
  </app-header-spinner>
  <app-form-spinner></app-form-spinner>
</div>

 <!--contact us promo section start-->
 <section class="contact-promo ptb-120">
  <div class="container">
      <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6 mt-4 mt-lg-0">
              <div class="contact-us-promo p-5 bg-white rounded-custom custom-shadow text-center d-flex flex-column h-100">
                  <span class="fas fa-comment fa-3x text-primary"></span>
                  <div class="contact-promo-info mb-4">
                      <h5>Chat with us</h5>
                      <p>We've got live Social Experts waiting to help you <strong>monday to friday</strong> from
                          <strong>9am to 5pm EST.</strong>
                      </p>
                  </div>
                  <a href="mailto:hello@arenasPasses.com" class="btn btn-link mt-auto">Chat with us</a>
              </div>
          </div>
          <div class="col-lg-4 col-md-6 mt-4 mt-lg-0">
              <div class="contact-us-promo p-5 bg-white rounded-custom custom-shadow text-center d-flex flex-column h-100">
                  <span class="fas fa-envelope fa-3x text-primary"></span>
                  <div class="contact-promo-info mb-4">
                      <h5>Email Us</h5>
                      <p>Simple drop us an email at <strong>
                        {{"hello@arenasPasses.com"}}
                      </strong>
                          and you'll receive a reply within 24 hours</p>
                  </div>
                  <a href="mailto:hello@arenasPasses.com" class="btn btn-primary mt-auto">Email Us</a>
              </div>
          </div>
          <div class="col-lg-4 col-md-6 mt-4 mt-lg-0">
              <div class="contact-us-promo p-5 bg-white rounded-custom custom-shadow text-center d-flex flex-column h-100">
                  <span class="fas fa-phone fa-3x text-primary"></span>
                  <div class="contact-promo-info mb-4">
                      <h5>Give us a call</h5>
                      <p>Give us a ring.Our Experts are standing by <strong>monday to friday</strong> from
                          <strong>9am to 5pm EST.</strong>
                      </p>
                  </div>
                  <a href="tel:00-976-561-008" class="btn btn-link mt-auto">00-976-561-008</a>
              </div>
          </div>
      </div>
  </div>
</section>
<!--contact us promo section end-->
<div class="container bg-white p-4" *ngIf="!loading">

<!--page header section end-->
  <div class="row">
  <div class="col-lg-12">
    <div class="card px-6 ">
     <div class="card-header">
       <h2>
         Any Question?
       </h2>
     </div>
     <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

       <div class="form-group">
         <label for="name">Name</label>
         <input
           type="text"
           id="name"
           class="form-control"
           formControlName="name"
         />
         <div
           *ngIf="form.get('name')?.hasError('required') && form.get('name')?.touched"
           class="text-danger"
         >
           Name is required.
         </div>
       </div>

       <div class="form-group">
         <label for="email">Email</label>
         <input
           type="email"
           id="email"
           class="form-control"
           formControlName="email"
         />
         <div
           *ngIf="
             form.get('email')?.hasError('required') &&
             form.get('email')?.touched
           "
           class="text-danger"
         >
           Email is required.
         </div>
         <div
           *ngIf="
             form.get('email')?.hasError('email') &&
             form.get('email')?.touched
           "
           class="text-danger"
         >
           Please enter a valid email address.
         </div>
       </div>

        <div class="form-group my-2">
          <label for="description">Description</label>
           <textarea name="description" id="" cols="30" rows="20" formControlName="description" class="form-control"></textarea>
          <div *ngIf="form.get('description')?.hasError('required') && form.get('description')?.touched" class="error-message text-danger">
            Description is required.
          </div>
        </div>

         <div class="row">
           <button type="submit" [disabled]="form.invalid" class="btn btn-primary">Submit</button>
         </div>


      </form>


     </div>
    </div>
  </div>
  </div>


</div>






